import { createElement } from 'react';
import { useUniqueId } from '../uniqueId.js';
import { string, node, oneOfType, element, bool } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { a as _objectSpread, b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Text/styled.js';
import '../Text/index.js';
import './styled.js';
import CardCard, { cardCardPropTypes, cardCardDefaultProps } from './CardCard.js';
export { default as CardCard, cardCardDefaultProps, cardCardPropTypes } from './CardCard.js';
import CardHeader from './CardHeader.js';
export { default as CardHeader, cardHeaderDefaultProps, cardHeaderPropTypes } from './CardHeader.js';
import CardContent from './CardContent.js';
export { default as CardContent, cardContentDefaultProps, cardContentPropTypes } from './CardContent.js';
import CardTitle from './CardTitle.js';
export { default as CardTitle, cardTitleDefaultProps, cardTitlePropTypes } from './CardTitle.js';
import CardFooter from './CardFooter.js';
export { default as CardFooter, cardFooterDefaultProps, cardFooterPropTypes } from './CardFooter.js';
import ConditionalWrap from 'conditional-wrap';

var Card = function Card(_ref) {
  var _a11yDescriptionId = _ref.a11yDescriptionId,
      _a11yTitleId = _ref.a11yTitleId,
      children = _ref.children,
      footer = _ref.footer,
      headerActions = _ref.headerActions,
      title = _ref.title,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yDescriptionId", "a11yTitleId", "children", "footer", "headerActions", "title"]);

  var titleId = useUniqueId('Card');
  var descriptionId = useUniqueId('Card');
  var a11yDescriptionId = _a11yDescriptionId || descriptionId;
  var a11yTitleId = _a11yTitleId || titleId;
  return createElement(CardCard, _extends({
    a11yDescriptionId: title || footer ? a11yDescriptionId : undefined,
    a11yTitleId: title ? a11yTitleId : undefined
  }, props), title && createElement(CardHeader, null, typeof title === 'string' ? createElement(CardTitle, {
    id: a11yTitleId
  }, title) : title, headerActions && createElement("div", null, headerActions)), createElement(ConditionalWrap, {
    condition: title || footer,
    wrap: function wrap(children) {
      return createElement(CardContent, {
        id: a11yDescriptionId
      }, children);
    }
  }, children), footer && createElement(CardFooter, null, footer));
};

Card.Card = CardCard;
Card.Header = CardHeader;
Card.Content = CardContent;
Card.Footer = CardFooter;
Card.Title = CardTitle;

var cardPropTypes = _objectSpread({}, cardCardPropTypes, {
  a11yDescriptionId: string,
  a11yTitleId: string,
  children: node.isRequired,
  className: string,
  footer: oneOfType([string, element]),
  headerActions: element,
  isFullWidth: bool,
  title: oneOfType([string, element])
});

Card.propTypes = cardPropTypes;

var cardDefaultProps = _objectSpread({}, cardCardDefaultProps, {
  a11yDescriptionId: undefined,
  a11yTitleId: undefined,
  className: undefined,
  footer: undefined,
  headerActions: undefined,
  isFullWidth: false,
  title: undefined
});

Card.defaultProps = cardDefaultProps; // @ts-ignore

var C = Card;
export default C;
export { C as Card, cardDefaultProps, cardPropTypes };